module.exports = __webpack_public_path__ + "media/images/clock-black-a4d4d9c84d91b3892c18fbfda112c72b.svg";